import { ObjectHelpers } from 'Helpers/ObjectHelpers'
import { get, isEmpty, last } from 'lodash'
import { makeAutoObservable, runInAction, toJS } from 'mobx'
import { Paths } from 'Routers/Paths'
import StoreCountry from '../County/StoreCountry'
import StoreLoader from '../Elements/StoreLoader'
import { getDictionary } from './Services'
class Translator {
    currentLanguage = ''
    currentPage = ''

    dictionaries = {}
    loading = false

    dictionaryStaticComponent = {}

    lists = {}

    Dictionaries() {
        const page = getDictionaryPage()
        if (this.currentPage !== page) {
            runInAction(() => {
                this.currentPage = page
            })
        }

        if (this.lists[this.currentPage]) {
            runInAction(() => {
                this.dictionaries = this.lists[this.currentPage]
            })
        } else {
            if (!this.lists[page] && this.loading === false) {
                this.loading = true
                this.getTranslations()
            }
        }

        return this.dictionaries
    }

    CurrentLanguage() {
        return this.currentLanguage
    }

    SetCurrentLanguage(value) {
        runInAction(() => {
            // console.log("some want to show this lang ", toJS(value))
            localStorage.setItem('currentLanguage', value)
            this.currentLanguage = value
        })
    }

    async getTranslations() {
        try {
            runInAction(() => {
                StoreLoader.dictionary = false
            })
            let getPage = `feelgreat/${this.currentPage}`
            if (!isEmpty(this.dictionaries)) {
                runInAction(() => {
                    this.lists[this.currentPage] = this.dictionaries
                    this.loading = false
                    StoreLoader.dictionary = true
                })
                return
            }
            let dictionaries = await getDictionary(StoreCountry.Country3(), getPage)
            runInAction(() => {
                this.dictionaries = dictionaries
                this.lists[this.currentPage] = this.dictionaries
                this.dictionaryStaticComponent = this.dictionaries
                this.loading = false
                StoreLoader.dictionary = true
            })
        } catch (e) {}
    }

    async FetchDictionaryStaticComponent() {
        if (ObjectHelpers.isEmpty(this.dictionaryStaticComponent)) {
            const translated = await getDictionary(StoreCountry.Country3(), 'feelgreat/staticComponents')
            runInAction(() => {
                this.dictionaryStaticComponent = translated
            })
        }
    }

    GetDictionaryStaticComponents() {
        return this.dictionaryStaticComponent
    }

    constructor() {
        const page = getDictionaryPage()
        runInAction(() => {
            this.currentPage = page
        })

        if (!this.lists[page] && this.loading === false) {
            this.loading = true
            this.getTranslations()
        }

        // if (ObjectHelpers.isEmpty(this.dictionaryStaticComponent)) {
        //     this.FetchDictionaryStaticComponent()
        // }

        makeAutoObservable(this)
    }
}

class StoreTranslator {
    instance = null
    /**
     * @returns {Translator} Translator
     */
    Instance() {
        if (this.instance === null) {
            this.instance = new Translator()
        }

        return this.instance
    }

    Dictionaries() {
        return this.Instance().Dictionaries()
    }

    CurrentLanguage() {
        return this.Instance().CurrentLanguage()
    }

    SetCurrentLanguage(value) {
        this.Instance().SetCurrentLanguage(value)
    }

    IsEnglish() {
        return this.Instance().CurrentLanguage() === 'EN'
    }

    UseLanguage(content) {
        if (content) {
            if (this.CurrentLanguage() === 'EN') {
                return content.english
            } else {
                if (content.native) {
                    return content.native
                } else {
                    return content.english
                }
            }
        }

        return ''
    }

    GetDictionaryStaticComponents(key) {
        return this.Instance().GetDictionaryStaticComponents()
    }

    constructor() {
        makeAutoObservable(this)
    }
}

function getDictionaryPage() {
    let page = last(window.location.pathname.split('/'))

    const foundPageRegx = pageMapperList.find(rx => window.location.pathname.match(rx))

    if (PageMapper[page]) {
        page = PageMapper[page]
    } else if (foundPageRegx) {
        const [matchedPage] = window.location.pathname.match(foundPageRegx)
        page = matchedPage
    } else if (Paths.includes(page)) {
        page = page
    } else {
        page = 'landing'
    }
    return page
}

const PageMapper = {
    checkout: 'order_detail_2022',
    ordersummary: 'summary',
    success: 'paymentResponse',
    failed: 'paymentResponse',
    referral: 'referral'
}

const pageMapperList = [
    /centurion/,
    /user/,
    /checkout/,
    /login/,
    /register-new-ba/,
    /new-password-error/,
    /new-password-success/,
    /new-password/,
    /sign-up/,
    /contact-us/
]

export default StoreTranslator = new StoreTranslator()
